import React from 'react';

type FullScreenSizeProps = {
  children: React.ReactNode;
};

export const FullScreenSize: React.FC<FullScreenSizeProps> = ({ children }) => {
  return <div className="h-screen w-screen flex">{children}</div>;
};
